export default __webpack_public_path__ + "static/media/other_bank_dark.bfd28127.png";